import styled from "@emotion/styled";
import theme from "../../styles/theme";
import { Link } from "gatsby";

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const ResourceButton = styled(Link)`
  color: ${theme.colors.blues[100]};
  display: inline-block;
  font-size: 20px;
  text-decoration: none;
  &:hover {
    cursor: pointer;
  }
`;

export const ResourcesPostsBase = styled.div``;

export const Headline = styled.h2`
  text-align: center;
  margin: 0 auto 28px;

  ${theme.largerThan.sm} {
    margin-bottom: 40px;
  }
`;

export const Posts = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-column-gap: 24px;
  grid-row-gap: 24px;

  ${theme.largerThan.sm} {
    grid-row-gap: 48px;
    margin-bottom: 48px;
  }

  ${theme.largerThan.lg} {
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  }

  ${theme.largerThan.xl} {
    grid-template-columns: repeat(auto-fit, minmax(224px, 1fr));
  }

  & > a {
    height: 258px;

    ${theme.largerThan.md} {
      height: 315px;
      min-width: 160px;
    }
  }
`;
